import type { ObjectAllowedFeaturesType } from './allowedFeaturesUtils';

export const isRedirectionEnabled = (feature: ObjectAllowedFeaturesType): boolean => {
	if (typeof feature === 'object') {
		return 'enable-redirection' in feature;
	}

	if (typeof feature === 'string') {
		try {
			const parsedFeature = JSON.parse(feature);
			return (
				parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature
			);
		} catch {
			return false;
		}
	}
	return false;
};
